<template>
<div>

    <div class="box box-info">
		<div class="box-header with-border">
            <h3>Formato del archivo .csv ó .xlsx de EMPLEADOS - TURNOS <el-button size="small" type="info" @click="downloadTemplate">Descargar plantilla</el-button></h3>
			<div class="box-tools pull-right">
				<button type="button" class="btn btn-box-tool" @click="handleClose" data-original-title="Cancelar">
				<i class="fa fa-times"></i></button>
			</div>
        </div>
        <div class="box-body">
            <el-table :data="employees_shifts_data" border style="width: 100%">
                <el-table-column prop="id_number" label="Cédula"></el-table-column>
                <el-table-column prop="name" label="Nombre"></el-table-column>
                <el-table-column prop="day1" label="2020-01-20"></el-table-column>
                <el-table-column prop="day2" label="2020-01-21"></el-table-column>
                <el-table-column prop="day3" label="2020-01-22"></el-table-column>
                <el-table-column prop="day4" label="2020-01-23"></el-table-column>
                <el-table-column prop="day5" label="2020-01-24"></el-table-column>
            </el-table>
            <div><label>* El archivo debe tener formato .csv (valores separados por punto y coma) ó .xlsx. DEBE incluir la cabecera con los nombres de los campos y las fechas para las cuales se asignan los turnos.</label></div>
            <div><label>* Se incluye una columna por cada día en formato YYYY-MM-DD. Puede haber cualquier cantidad de días.</label></div>
        </div>
        <el-upload
            class="upload-demo"
            ref="upload"
            action="/api/batchprocesses/employeesshiftsdaysincolumns"
            accept=".csv, .xlsx, .xls"
            :auto-upload="false"
            :headers="headers"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            name="batch_file">
            <el-button slot="trigger" size="small" type="primary">Seleccionar archivo</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Subir archivo</el-button>
            <div class="el-upload__tip" slot="tip">archivos .csv ó .xlsx de hasta 10MB</div>
        </el-upload>
    </div>


</div>
</template>

<script>
    export default {
		name: 'shift-file-upload',
        data: function() {
            return {
                downloadUrl: null,
                status_codes: {
                    '0': 'Subido',
                    '1': 'Procesando',
                    '2': 'Ok',
                    '3': 'Error'
                },
                employees_shifts_data: [
                    {
                        id_number: '79861468',
                        name: 'LUCIA, QUINTERO',
                        day1: '06a14',
                        day2: 'DESCANSO',
                        day3: '14a22',
                        day4: '14a22',
                        day5: '14a22'
                    }, {
                        id_number: '19449639',
                        name: 'CATALINA, VILLAMIL',
                        day1: '10a18',
                        day2: '13a21',
                        day3: '10a18',
                        day4: '13a21',
                        day5: '10a18'
                    }, {
                        id_number: '52161869',
                        name: 'ANTONIO, LOPEZ',
                        day1: 'INCAPACIDAD',
                        day2: 'INCAPACIDAD',
                        day3: '10a20',
                        day4: '10a20',
                        day5: ''
                    }
                ],
                headers:{
                    'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }
        },
		watch: {
			'$route': function (to) {
                this.setDownloadUrl();
			}
		},
        mounted() {
            this.setDownloadUrl();
        },
        methods: {
            setDownloadUrl: function () {
                // console.log(this.$route);
                this.queryString = $.param(this.$route.query);
                if (this.$route.query.date_from != undefined 
                    && this.$route.query.date_to != undefined 
                    && this.$route.query.date_from != null 
                    && this.$route.query.date_to != null) {
                    // this.downloadUrl = '/api' + this.baseUrl+'/download?'+this.queryString;
                    this.downloadUrl = '/api/reports/shiftassignmentdatestocolumns/downloadtemplate?'+this.queryString;
                } else {
                    this.downloadUrl = null;
                }
            },
            downloadTemplate() {
                window.location.href = this.downloadUrl+'&token='+localStorage.getItem('id_token');
            },
            handleClose() {
                this.$refs.upload.clearFiles();
                this.$emit('close');
            },
            submitUpload() {
                this.$refs.upload.submit();
            },
            uploadSuccess(response, file, fileList) {
                this.$refs.upload.clearFiles();
                this.$notify({
                    title: 'Operación exitosa',
                    message: 'El archivo se procesó exitosamente',
                    type: 'success'
                });
                this.$emit('fileUploaded');
            },
            uploadError(error, file, fileList) {
                this.$refs.upload.clearFiles();
                this.$alert(JSON.parse(error.message).message + '<br>Por favor corrija los errores en el archivo y vuelva a subirlo.', 'Error', {
                    confirmButtonText: 'OK',
                    dangerouslyUseHTMLString: true
                });
                this.$emit('fileUploadedError');
            },
        }
    }
</script>
